import { render, staticRenderFns } from "./addcurriculumType.vue?vue&type=template&id=7975daa1&scoped=true&"
import script from "./addcurriculumType.vue?vue&type=script&lang=js&"
export * from "./addcurriculumType.vue?vue&type=script&lang=js&"
import style0 from "./addcurriculumType.vue?vue&type=style&index=0&id=7975daa1&lang=scss&scoped=true&"
import style1 from "./addcurriculumType.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7975daa1",
  null
  
)

export default component.exports